"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _values = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/values"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _AlertHelper = require("../../../../helpers/AlertHelper");

var _QuizService = require("./QuizService");

var _RoundService = _interopRequireDefault(require("./RoundService"));

var _default = {
  questions: [],
  requestQuestionsFromServerForRounds: function requestQuestionsFromServerForRounds(roundIds) {
    return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      var questionIds, loadedQuestions;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              questionIds = [];
              roundIds.forEach(function (roundId) {
                if (!roundId) {
                  throw new Error('something expected is not defined');
                }

                var round = _RoundService["default"].get(roundId);

                if (round !== null) {
                  questionIds = questionIds.concat(round.questions);
                }
              });
              console.log('requesting questions: ', questionIds);
              _context.prev = 3;
              _context.next = 6;
              return (0, _QuizService.getQuestions)(questionIds);

            case 6:
              loadedQuestions = _context.sent;
              return _context.abrupt("return", _promise["default"].resolve(loadedQuestions));

            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](3);
              console.log(_context.t0);
              return _context.abrupt("return", _promise["default"].resolve(null));

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[3, 10]]);
    }))();
  },
  preload: function preload(roundId) {
    var _this = this;

    return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
      var loadedQuestions;
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return (0, _QuizService.getQuestions)(_RoundService["default"].get(roundId).questions);

            case 3:
              loadedQuestions = _context2.sent;

              if (loadedQuestions.length === 0) {
                (0, _AlertHelper.showAlertWithOptions)({
                  message: 'Fehler beim Laden der Fragen. Bitte überprüfen Sie Ihre Internetverbindung.'
                }); // showAlert('Fehler beim Laden der Fragen. Bitte überprüfen Sie Ihre Internetverbindung.')
                // return null
              }

              console.log('successfully got questions');
              _this.questions = loadedQuestions;
              return _context2.abrupt("return", _promise["default"].resolve(_this.questions));

            case 10:
              _context2.prev = 10;
              _context2.t0 = _context2["catch"](0);
              console.log('error getting questions', _context2.t0);
              (0, _AlertHelper.showAlertWithOptions)({
                message: 'Fehler beim Laden der Fragen'
              }); // showAlert('Fehler beim Laden der Fragen')

              return _context2.abrupt("return", _promise["default"].resolve(_this.questions));

            case 15:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 10]]);
    }))();
  },
  get: function get(questionId) {
    var returnValue;
    (0, _values["default"])(this.questions).forEach(function (question) {
      if (!question.value) {
        throw new Error('something expected is not defined');
      }

      if (question.value.emsId === questionId) {
        returnValue = question.value;
      }
    });
    return returnValue;
  }
};
exports["default"] = _default;